import { Typography, styled } from '@mui/material';

const StyledDashboardBlockTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 800,
  letterSpacing: '-0.01em',
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.pxToRem(22)
  }
}));

export default StyledDashboardBlockTitle;
